import { MouseButton } from '@/types/types';
import { ProjectRenderer } from '../ProjectRenderer';
import { RENDERER_CONFIG } from '@/configs/rendererConfig';
import { Vector2, Raycaster } from 'three';

export class Mouse {
	private mouse = new Vector2();
	private mouseDown = new Vector2();
	private raycaster = new Raycaster();

	constructor(private renderer: ProjectRenderer) {
		this.renderer = renderer;
		this.mouseMove = this.mouseMove.bind(this);
		this.onMouseDown = this.onMouseDown.bind(this);
		this.onMouseUp = this.onMouseUp.bind(this);
	}

	init() {
		this.raycaster.layers.enable(RENDERER_CONFIG.SELECTABLE_LAYER);

		this.renderer.canvas!.addEventListener('mousemove', this.mouseMove);
		this.renderer.canvas!.addEventListener('mousedown', this.onMouseDown);
		this.renderer.canvas!.addEventListener('mouseup', this.onMouseUp);
	}

	private mouseMove(event: MouseEvent) {
		event.preventDefault();

		const rect = this.renderer.canvas!.getBoundingClientRect();
		this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
		this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

		this.raycaster.setFromCamera(
			this.mouse,
			this.renderer.cameraController.camera
		);
	}

	private onMouseDown(event: MouseEvent) {
		event.preventDefault();

		this.mouseDown.copy(this.mouse);

		if (event.button === MouseButton.MIDDLE) return;

		if (event.button === MouseButton.RIGHT) {
			return;
		}
	}

	private onMouseUp(event: MouseEvent) {
		event.preventDefault();

		this.mouseDown.set(0, 0);
	}
}
